export default function (object) {
    // check if object is an empty object
    if (object === null || object === undefined) return false
    return Object.keys(object).length > 0
}
